import {Button} from "antd";
import React, {useEffect, useState} from "react";
import {HttpService} from "../../services/http/Http.service";
import {StatusCodeE} from "../../model/models";
import {HttpErrorService} from "../../services/http/HttpError.service";

interface SelectAllButtonProps {
    idSimulator: string,
    status: StatusCodeE,
    onSelected: (selectedRowKeys: string[]) => void,
    onTotalChange?: (value: (((prevState: number) => number) | number)) => void,
    resetSelectAll?: boolean
}

export function SelectAllButton({
                                    idSimulator,
                                    status,
                                    onSelected,
                                    onTotalChange,
                                    resetSelectAll
                                }: SelectAllButtonProps) {

    const [selected, setSelected] = useState<boolean>(false);

    async function selectAll() {
        setSelected(true);
        try {
            const data = await HttpService.getInstanceAxios().get(`/simulazione/${idSimulator}/file-ts/status/${status}/person/all`)
            if (data.data) {
                if (onSelected)
                    onSelected(data.data)
            }
        } catch (error) {
            HttpErrorService.handle("Errore durante la selezione di tutte le pratiche", error, true)
        }
    }

    function deselectAll() {
        setSelected(false);
        onSelected([]);
        if (onTotalChange) {
            onTotalChange(0);
        }
    }

    useEffect(() => {
        if (resetSelectAll) {
            setSelected(false);
            onSelected([]);
            if (onTotalChange) onTotalChange(0);
        }
    }, [resetSelectAll]);

    return (
        <>
            {selected ?
                <Button className="visualize-button"
                        onClick={() => deselectAll()}>
                    Deseleziona Tutti
                </Button> :
                <Button className="visualize-button"
                        onClick={() => selectAll()}>
                    Seleziona Tutti
                </Button>
            }

        </>
    )
}